export default __webpack_public_path__ + "static/media/landing_bg3_half1.6d0daa97.png";